import UserMediaUploadDocumentForm from './UserMediaUploadDocumentForm';

export default UserMediaUploadDocumentForm;
